import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail, MapPin } from "lucide-react";
import WaveDivider from "@/components/WaveDivider";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative">
    <WaveDivider fill="#0A1F2D" />
    <div className="bg-gradient-to-b from-ocean-deep to-ocean text-white">
      <div className="max-w-7xl mx-auto px-5 md:px-8 pt-16 pb-10 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-1">
          <div className="flex items-center gap-3 mb-4">
            <span
              aria-hidden="true"
              className="w-12 h-12 rounded-full shrink-0 bg-cream ring-1 ring-white/20"
              style={{ backgroundImage: "url(/logo.png)", backgroundSize: "300%", backgroundPosition: "center 18%" }}
            />
            <span className="font-serif text-2xl leading-none">Beachside</span>
          </div>
          <p className="text-white/70 text-sm leading-relaxed max-w-xs">
            Solo mobile bartending crafting coastal cocktail moments across the Sunshine Coast.
          </p>
          <div className="flex gap-3 mt-6">
            {[Instagram, Facebook].map((Icon, i) => (
              <a key={i} href="#" data-testid={`footer-social-${i}`} className="w-10 h-10 rounded-full border border-white/20 grid place-items-center hover:bg-coral hover:border-coral transition-colors">
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="overline text-xs text-coral mb-5">Explore</h4>
          <ul className="space-y-3 text-sm text-white/80">
            <li><a href="/#about" className="link-underline">About</a></li>
            <li><a href="/#packages" className="link-underline">Packages</a></li>
            <li><a href="/#faq" className="link-underline">FAQ</a></li>
            <li><a href="/#contact" className="link-underline">Contact</a></li>
          </ul>
        </div>

        <div>
          <h4 className="overline text-xs text-coral mb-5">Tools</h4>
          <ul className="space-y-3 text-sm text-white/80">
            <li><Link to="/quote" className="link-underline">Quote Calculator</Link></li>
            <li><Link to="/assistant" className="link-underline">Booking Assistant</Link></li>
            <li><Link to="/cocktails" className="link-underline">Cocktail Advisor</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="overline text-xs text-coral mb-5">Get in touch</h4>
          <ul className="space-y-3 text-sm text-white/80">
            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-coral" /> Sunshine Coast, QLD<br />Noosa · Caloundra & surrounds</li>
            <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-coral" /> BeachsideBartending@gmail.com</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-6 flex flex-col md:flex-row justify-between gap-3 text-xs text-white/50">
          <span>© {new Date().getFullYear()} Beachside Bartending. All rights reserved.</span>
          <span className="overline">Sunshine Coast · Queensland</span>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
